/**
 * Helpers for athlete package-related API errors.
 *
 * These functions interpret the normalized ApiErrorResponse shape
 * for athlete package operations (cancel/delete, etc.).
 */

import { ERROR_CODES } from 'api/error-handling/error-codes';
import type { ApiErrorResponse } from 'types/api-error';

export interface BlockingInvoiceErrorData {
  blockingInvoiceId: string | null;
  isChildPackageError: boolean;
}

export function getBlockingInvoiceErrorData(error: ApiErrorResponse): BlockingInvoiceErrorData | null {
  if (error.errorCode !== ERROR_CODES.ATHLETE_PACKAGE.BLOCKED_BY_INVOICE) {
    return null;
  }

  const details = (error.details ?? {}) as {
    blockingInvoiceIds?: string[];
    childPackageId?: string;
  };

  const blockingInvoiceIds = details.blockingInvoiceIds || [];
  const blockingInvoiceId = blockingInvoiceIds.length > 0 ? blockingInvoiceIds[0] : null;
  const isChildPackageError = Boolean(details.childPackageId);

  return {
    blockingInvoiceId,
    isChildPackageError,
  };
}
